CTA_EVENT_CATEGORY_DEFAULT = 'cta-unknown';

function addCtaClickListener() {
  const elements = document.querySelectorAll('[data-cta-click]');
  elements.forEach(element => {

    element.addEventListener('click', (() => {
      const { gaAction, gaCategory, gaLabel } = element.dataset;
      sendGoogleAnalyticsEvent(gaAction, gaCategory, gaLabel);
    }));
  })
}

function sendGoogleAnalyticsEvent(gaAction, gaCategory, gaLabel) {
  gtag('event', gaAction, {
    'event_category': gaCategory || this.CTA_EVENT_CATEGORY_DEFAULT,
    'event_label': gaLabel
  });
}

function replayVideos() {
  const videoElements = document.getElementsByTagName("video");
  for (let i = 0; i < videoElements.length; i++) {
    const video = videoElements[i];
    if (video.autoplay && !video.playing) {
      video.play();
    }
  }
}
function videoListener() {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      replayVideos();
    }
  });

  const event = 'ontouchstart' in window ? 'touchstart' : 'scroll';
  window.addEventListener(event, replayVideos, { once: true });
}

addCtaClickListener();
videoListener();
